import {createContext} from 'preact';
import type {Dispatch} from 'preact/hooks';

import type {AuthorizeState, AuthorizeStateAction} from '~/types/authorize';

import {initialAuthorizeState} from './reducer';

export interface AuthorizeContextValue {
  dispatch: Dispatch<AuthorizeStateAction>;
  state: AuthorizeState;
}

export const DEFAULT_CONTEXT_VALUE: AuthorizeContextValue = {
  dispatch: () => {
    throw new Error(
      'Invalid attempt to call dispatch outside of Authorize context.',
    );
  },
  state: initialAuthorizeState,
};

export const AuthorizeContext = createContext<AuthorizeContextValue>(
  DEFAULT_CONTEXT_VALUE,
);
